import type { MantineSize } from '@mantine/core';
import { TimePicker } from '@mantine/dates';

export interface TimeFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string | boolean;
  disabled?: boolean;
  size?: MantineSize;
  style?: React.CSSProperties;
}

export function TimeField({
  label,
  value,
  onChange,
  required,
  error,
  disabled,
  size,
  style,
}: TimeFieldProps) {
  return (
    <TimePicker
      label={label}
      value={value}
      onChange={onChange}
      format="12h"
      withDropdown
      required={required}
      error={error}
      disabled={disabled}
      size={size}
      style={style}
    />
  );
}
